import script from "./advancePayment.vue?vue&type=script&setup=true&lang=js"
export * from "./advancePayment.vue?vue&type=script&setup=true&lang=js"

import "./advancePayment.vue?vue&type=style&index=0&id=710d3030&lang=scss&scoped=true"

import exportComponent from "D:\\workFolder\\payment-H5\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-710d3030"]])

export default __exports__